import React from 'react';
import { CheckIcon, SproutIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach environmental management with confidence starting today'];
export function FinalCta() {
  return <section className="bg-navyDeep py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jbah2bzm0e0u">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1ed8yds63igpw">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-solar" data-id="element-72" data-mp="1t2ojariy3rxo">
          <SproutIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o3lgldqftxsv" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="222uw0b6tknvs">
          Created by environmental education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-75" data-mp="n6w72z5gtqc7" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl bg-white p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n7ywt3r1xmqj">
          <p data-id="element-77" data-mp="x3iofdyl1z9h">
            <b className="block text-sm uppercase leading-tight text-navy" data-id="element-78" data-mp="x2za07855t07">{productShortName}</b>
            <span className="text-sm text-muted" data-id="element-79" data-mp="123myal4zjvqq">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="1b3a21dl6tdmy">
            <p className="text-sm text-muted" data-id="element-81" data-mp="1b28litlejyxu">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1fu9uo6n9x9jn">{priceBefore}</span>
              <b className="text-base text-navy" data-id="element-83" data-mp="1fv1q9hgvf79x">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1ks1ox7be57r0">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-white/75" data-id="element-85" data-mp="1tuuft9gnvhgb">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3lvkpk8bu940n">
              <CheckIcon className="h-4 w-4 text-solar" aria-hidden="true" data-id="element-87" data-mp="3lthngpxevkfk" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}